import React from 'react';
import { useQuery } from 'react-query';
import { Link, useHistory, useLocation } from 'react-router-dom';

import {
  AppBar,
  Box,
  Button,
  ButtonBase,
  Grid,
  Hidden,
  IconButton,
  Link as MuiLink,
  Theme,
  Toolbar,
  Typography,
  makeStyles,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';

import NotificationBell from '../../assets/img/icon/Bell.svg';
// import NotificationBell from '../../assets/img/notification-bell.png';
import WhatsappSrc from '../../assets/img/whatsapp.svg';
// import WhatsappSrc from '../../assets/img/whatsapp.png';
import { appConfig } from '../../config/app';
import { useAuthDataContext } from '../../context/auth/auth.provider';
import {
  CANCEL_SELF_INSPECTIONS,
  useSidebarContext,
} from '../../context/sidebar/sidebar.provider';
import {
  NOTIFICATIONS_QUERY,
  notificationsQuery,
} from '../../query/notifications/notifications';
import SharedDialog from '../SharedDialog/SharedDialog.component';

const useStyles = makeStyles((theme: Theme) => ({
  menuIcon: {
    height: '30px',
    width: '30px',
    fill: theme.palette.secondary.main,
    // fill: theme.palette.secondary.main,
  },
  appBarMobile: {
    top: 'auto',
    bottom: 0,
    backgroundColor: 'white',
  },
  appListMobile: {
    display: 'flex',
    '& a': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      '& .MuiListItemIcon-root': {
        justifyContent: 'center',
      },
    },
  },
}));

const Header = (props) => {
  const { open, setOpen, isStepper, stepperTitle, setRecentCancel, step } =
    useSidebarContext();
  const { onLogout } = useAuthDataContext();
  const history = useHistory();
  let location = useLocation();
  const { user } = useAuthDataContext();
  const [dialog, setDialog] = React.useState(false);
  const [hasToLogin, setHasToLogin] = React.useState(false);
  const { data: notifications } = useQuery(
    NOTIFICATIONS_QUERY,
    notificationsQuery,
    {
      onError: (error: any) => {
        error.response.status === 401 && !hasToLogin && setHasToLogin(true);
      },
    }
  );

  let hideIconMenuButton =
    history.location.pathname.includes('account/payment') ||
    history.location.pathname.includes('account/incidents') ||
    history.location.pathname.includes('account/modified_payments') ||
    history.location.pathname.includes('account/payments');

  let includesCancelPolicy = history.location.pathname.includes(
    'cancel-policy/vehicle'
  );

  // const Transition = React.forwardRef(function Transition(
  //   props: TransitionProps & {
  //     children: React.ReactElement<any, any>;
  //   },
  //   ref: React.Ref<unknown>
  // ) {
  //   return <Slide {...props} direction="up" ref={ref} />;
  // });

  const { embed } = useAuthDataContext();
  const redirectHome = () => {
    embed
      ? window.parent.postMessage({ return: 'overview' }, '*')
      : history.push('/dashboard');
  };

  const handleSideBar = () => {
    if (
      location.pathname.includes('sinister') ||
      location.pathname.includes('assistance') ||
      location.pathname.includes('selfInspection')
    ) {
      setDialog(!dialog);

      if (location.pathname.includes('selfInspection')) {
        setRecentCancel(CANCEL_SELF_INSPECTIONS);
      }
    } else {
      redirectHome();
    }
  };

  const onClose = () => {
    redirectHome();
    setDialog(false);
  };

  return (
    <>
      <SharedDialog
        // TransitionComponent={Transition}
        open={hasToLogin}
        onClose={() => onLogout()}
        fullWidth
        content={
          <Box>
            <Typography variant="h6">Ha ocurrido un error</Typography>
            <Box my={2}>
              <Typography>
                ¡Lo sentimos! Te pedimos que intentes reiniciando tu sesión. En
                caso de que persista la falla, hablanos por Whatsapp
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="center" alignItems="center">
            <Grid item xs={12} sm={6}>
              <Box m={2} display="flex" alignItems="center">
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => onLogout()}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box m={2} display="flex" alignItems="center">
                <MuiLink
                  href={appConfig?.WHATSAPP_LINK}
                  rel="noopener"
                  target="_blank"
                >
                  <Button variant="outlined" color="secondary" fullWidth>
                    <img
                      src={WhatsappSrc}
                      alt="Whatsapp"
                      style={{ marginLeft: '15px' }}
                    />
                    <Typography display="inline">
                      Comunicarme vía Whatsapp
                    </Typography>
                  </Button>
                </MuiLink>
              </Box>
            </Grid>
          </Grid>
        }
      />

      <SharedDialog
        open={dialog}
        onClose={() => setDialog(false)}
        content={
          <Box>
            <Typography variant="h6">¡Atención!</Typography>
            <Box my={2}>
              <Typography>
                ¿Estas seguro que quieres ir al inicio?, perderás los cambios
                realizados.
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="outlined"
                  color="secondary"
                  fullWidth
                  onClick={() => setDialog(false)}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box m={2} display="flex" alignItems="center">
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => onClose()}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      />

      <AppBar
        color="transparent"
        position="sticky"
        style={{ backgroundColor: 'white' }}
      >
        <Toolbar>
          <ButtonBase onClick={handleSideBar}>
            <Hidden xsDown implementation="css">
              <img
                src={appConfig?.IMAGES?.APP_HEADER}
                alt="brand logo"
                style={{ maxHeight: '30px' }}
              />
            </Hidden>
            <Hidden smUp implementation="css">
              <img
                src={appConfig?.IMAGES?.APP_HEADER}
                alt="brand logo"
                style={{ maxHeight: '30px' }}
              />
            </Hidden>
          </ButtonBase>
          <Box
            mr={1}
            display="flex"
            alignItems="center"
            position="absolute"
            right={0}
          >
            <Box>
              {isStepper && (
                <Typography variant="caption">{stepperTitle}</Typography>
              )}
            </Box>

            <Box>
              {location.pathname.includes('dashboard') && (
                <Box>
                  <Typography variant="h4">
                    {/* <Typography color="primary" variant="h4"> */}
                    Hola {user?.first_name || user?.last_name || ''}
                  </Typography>
                </Box>
              )}
            </Box>

            <Box>
              {!!(notifications && notifications.length) && (
                <Box ml={2}>
                  <ButtonBase component={Link} to="/notifications">
                    <img
                      height="30px"
                      src={NotificationBell}
                      alt="Notificaciones"
                    />
                  </ButtonBase>
                </Box>
              )}
            </Box>

            <Box
            // mr={2}
            // display="flex"
            // alignItems="flex-end"
            // position="relative"
            // right={0}
            >
              {!isStepper && !hideIconMenuButton && (
                <IconButton>
                  <MenuIcon
                    style={{ color: '#000' }}
                    // color="primary"
                    // component={Button}
                    onClick={() => setOpen(!open)}
                  />
                </IconButton>
              )}

              {isStepper && step === 0 && !includesCancelPolicy && (
                <IconButton>
                  <MenuIcon
                    style={{ color: '#000' }}
                    // color="primary"
                    // component={Button}
                    onClick={() => setOpen(!open)}
                  />
                </IconButton>
              )}
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      {/* {
        !location.pathname.includes('dashboard') &&
        !location.pathname.includes('account') &&
        <Hidden smUp implementation="css">
          {access_token && !isStepper && (
            <AppBar
              position="fixed"
              color="default"
              className={classes.appBarMobile}
            >
              <List className={classes.appListMobile}>
                {routes.map(
                  (route, index) =>
                    !route.noDrawer && route.icon && (
                      <ListItem
                        button
                        key={index}
                        selected={selected === index}
                        onClick={() => {
                          setSelected(index);
                          setOpen(false);
                        }}
                        component={Link}
                        to={route.path}
                      >
                        <ListItemIcon>
                          <Box>{route.icon ? <route.icon /> : null}</Box>
                        </ListItemIcon>
                        <ListItemText primary={route.name} />
                      </ListItem>
                    )
                )}
              </List>
            </AppBar>
          )}
        </Hidden>
      } */}
    </>
  );
};

export default Header;
